import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'antd';

const TextArea = (props) => {
    return (
        <div className="form-group">
            {/* Phase C.7.4D-R1 (§4/§3): same fixes as MyInput.jsx/DropdownList.jsx — ent-required-asterisk
                for the zero-gap asterisk, and excluding the literal "success" tri-state value below so
                a validly-filled textarea (e.g. Address) doesn't render has-error/the close-circle icon. */}
            {props.heading &&
                <label htmlFor={props.name} className="card-holder-name">{props.heading}
                    {props.isRequired && <span className="color-red ent-required-asterisk">*</span>}
                </label>
            }
            <textarea
                onMouseUp={props.onMouseUp}
                rows={props.rows != undefined ? props.rows : "4"}
                cols="36"
                name={props.name}
                value={props.value}
                onChange={props.onChange}
                placeholder={props.placeholder}
                // Stage 3.6 (Enterprise Shared Component Stabilization): fixed a bug where, whenever
                // there was no error AND a `className` was passed, `.form-control` was dropped
                // entirely (unlike MyInput.jsx's equivalent line, which always keeps it) — this
                // control silently lost its base input styling in that case. Now matches MyInput's
                // pattern: `.form-control` is always present, `className`/`has-error` are additive.
                className={
                    `form-control ${props.className || ''} ${(props.errorState && props.errorState !== 'success') ? 'has-error' : ''}`.trim()
                }
            />
            {props.errorState && props.errorState !== 'success' && <label className="color-red d-block"><Icon type="close-circle" className="mr-1" />{props.errorMessage}</label>}
        </div>
    )
}

TextArea.propTypes = {
    heading: PropTypes.any,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    rows: PropTypes.any,
    className: PropTypes.string,
    errorState: PropTypes.string,
    errorMessage: PropTypes.string,
    isRequired: PropTypes.bool
};

export default TextArea;